import React from 'react';
import { Paper, Typography } from '@mui/material';
import { Science as ExperimentIcon } from '@mui/icons-material';

/**
 * EmptyState Component
 *
 * Empty state when no experiments are found.
 */
function EmptyState() {
  return (
    <Paper sx={{ p: 4, textAlign: 'center' }}>
      <ExperimentIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        No experiments found
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Create your first experiment to get started with A/B testing
      </Typography>
    </Paper>
  );
}

export default EmptyState;
